import { useState } from "react";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import { CabinetworksGroupApplication } from "types/declarations/enums.ts";
import { DashboardCard } from "./DashboardCard";
import { OrderLookupDialog } from "./OrderLookupDialog";
import { useDashboardNavigation } from "../hooks/useDashboardNavigation";
import { OrderLookupMode } from "../Dashboard.types";

const ordersIllustrationUrl = new URL("../assets/orders-card.svg", import.meta.url).href;

export const OrdersCard = () => {
	const goTo = useDashboardNavigation();
	const [lookupMode, setLookupMode] = useState<OrderLookupMode | null>(null);
	const tandemDestination = (href: string) => ({ href, application: CabinetworksGroupApplication.Tandem });

	return (
		<>
			<DashboardCard
				testId="dashboard-orders-card"
				title="Orders"
				illustration={
					<img
						src={ordersIllustrationUrl}
						alt=""
						aria-hidden="true"
					/>
				}
				accent="#a4c346"
				titleColor="#7ea034"
				actions={[
					{
						id: "track",
						label: "Track",
						icon: <SearchOutlinedIcon aria-hidden="true" />,
						onClick: () => goTo(tandemDestination("/orders"))
					},
					{
						id: "new-order",
						label: "New Order",
						icon: <AddBoxOutlinedIcon aria-hidden="true" />,
						onClick: () => goTo(tandemDestination("/new-order"))
					},
					{
						id: "replacement",
						label: "Replacement",
						icon: <ShieldOutlinedIcon aria-hidden="true" />,
						onClick: () => setLookupMode("replacement")
					},
					{
						id: "add-on",
						label: "Add-On",
						icon: <ContentCopyOutlinedIcon aria-hidden="true" />,
						onClick: () => setLookupMode("addOn")
					}
				]}
			/>
			<OrderLookupDialog
				mode={lookupMode}
				onClose={() => setLookupMode(null)}
			/>
		</>
	);
};
